import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, WritableSignal } from '@angular/core';
import { EChannel, IStandardParagraphNormalized } from '../../../../shared/models/standard-transcript-normalized.model';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { RenderParagraphDirective } from './directives/render-paragraph.directive';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'cv-standard-transcript',
  standalone: true,
  templateUrl: './standard-transcript.component.html',
  styleUrl: './standard-transcript.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RenderParagraphDirective, ButtonModule, NgOptimizedImage],
})
export class StandardTranscriptComponent {
  @Input() isMobile: boolean = false;
  @Input() paragraphs: IStandardParagraphNormalized[] = [];
  @Input({ required: true }) userName!: string | null;
  @Input({ required: true }) agentName!: string;
  @Input({ required: true }) currentAudioTime: number = 0;
  @Output() readonly playFromParagraph: EventEmitter<number> = new EventEmitter<number>();
  EChannel = EChannel;

  hoveredParagraphIndex: WritableSignal<number | null> = signal(null);

  onMouseToggle(index: number): void {
    if (!this.isMobile) {
      this.toggleActionButtons(index);
    }
  }

  onClick(index: number): void {
    if (this.isMobile) {
      this.toggleActionButtons(index);
    }
  }

  toggleActionButtons(index: number): void {
    if (typeof this.hoveredParagraphIndex() === 'number') {
      this.hoveredParagraphIndex.set(null);
    } else {
      this.hoveredParagraphIndex.set(index);
    }
  }
}
